"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTripDateValid = exports.isTripFolderDurationValid = void 0;
const moment_1 = __importDefault(require("moment"));
const folderValidationConsts_1 = require("./folderValidationConsts");
const isTripFolderDurationValid = (folder) => {
    const startDate = (0, moment_1.default)(folder.tripDate);
    const returnDate = (0, moment_1.default)(folder.returnDate);
    // reject if start date if after return date
    if (startDate.isAfter(returnDate, "days"))
        return false;
    // reject if trip duration is more than TRIP_MAXIMUM_DURATION_DAYS
    return returnDate.diff(startDate, "days") <= folderValidationConsts_1.TRIP_MAXIMUM_DURATION_DAYS;
};
exports.isTripFolderDurationValid = isTripFolderDurationValid;
const isTripDateValid = (tripDate, referenceDate) => {
    const referenceDateMoment = referenceDate ? (0, moment_1.default)(referenceDate) : (0, moment_1.default)();
    const tripDateMoment = (0, moment_1.default)(tripDate);
    const upperLimit = referenceDateMoment.clone().add(folderValidationConsts_1.TRIP_DATE_FUTURE_LIMIT_YEARS, "years");
    const lowerLimit = referenceDateMoment.clone().subtract(folderValidationConsts_1.TRIP_DATE_PAST_LIMIT_YEARS, "years");
    // Reject when given trip date is over the upper limit or under the lower limit
    return tripDateMoment.isBetween(lowerLimit, upperLimit, "day", "[]");
};
exports.isTripDateValid = isTripDateValid;
